<div id="POP" class="block black text-center">
    <div class="cage">
        <div class="ct-start-4-6 ctr-2-4 cage inner-cont">
            <div class="ct-start-1-12 ctr-start-1-6 body_01_xl_light divider" [innerHTML]="package.line001"></div>
            <div class="ct-start-1-12 ctr-start-1-6 caption_detail_s" [innerHTML]="package.line002"></div>
            <button class="ct-start-5-4 ctr-start-3-2 primary_button" (click)="emitTrigger()">{{package.buttonText | uppercase}}</button>
        </div>
    </div>
</div>